<div class="content_inner">

<ng-container *ngIf="elementData && elementData.type === 'paragraph'">
    <p [innerHTML]="elementData.paragraph.body"></p>
    <hr />
</ng-container>

<ng-container *ngIf="elementData && elementData.type === 'sampleimages'">
    <div class="sample" *ngIf="sampleImageList.length > 1">
        <div>
            <owl-carousel-o [options]="customOptions">
                <ng-container *ngFor="let image of sampleImageList">
                    <ng-template [width]="200" carouselSlide>
                        <div style="margin-right: 10px" class="item">
                            <h4><img style="border-radius: 7px;width: 100%;height: 150px;"
                                    [src]="image.image.images.thumbnail"></h4>
                        </div>
                    </ng-template>
                </ng-container>
            </owl-carousel-o>
        </div>
        <hr />
    </div>
    <div class="sample" *ngIf="sampleImageList.length === 1">
        <div>
            <img style="border-radius: 7px;width: 100%;height: 150px;" [src]="sampleImageList[0].image.images.thumbnail">
        </div>
        <hr />
    </div>
</ng-container>

<ng-container  *ngIf="elementData && elementData.type === 'quote'">
    <div class="qoute">
        <div class="qoute_box">
            <span class="prev"><img *ngIf="elementData.showQuotes"
                    src="../../../assets/images/qoute_prev.jpg"></span> {{elementData.paragraph.body}}
            <span class="next"><img *ngIf="elementData.showQuotes"
                    src="../../../assets/images/qoute_next.jpg"></span>
        </div>
        <hr />
    </div>
</ng-container>

<ng-container *ngIf="elementData && elementData.type === 'faq'">
    <div class="qna">
        <ul>
            <li *ngFor="let faq of elementData.faqs">
                <p class="qna_question">Q. {{faq.key}} ?</p>
                <p [innerHTML]="faq.value"></p>
            </li>
        </ul>

    </div>
</ng-container>

<ng-container *ngIf="elementData && elementData.type === 'listicleElement'">
    <div class="listicle bordered" *ngIf="elementData.listicleBulletType==='border'">
        <ul>
            <li *ngFor="let item of elementData.listicleArray;let i = index">
                <h2><span>{{i+1}}</span></h2>
                <h4>{{item.key}}</h4>
                <p>{{item.value}}</p>
                <div class="listImage">
                    <img *ngIf="item.mediaType === 'image'" src="{{item.media.image.images.original}}">
                    <div class="respVideo" *ngIf="item.mediaType === 'video'"
                        [innerHtml]="item.media.video.body | noSanitize">
                    </div>
                    <div #embedEl >
                        <div class="respVideo" *ngIf="item.mediaType === 'embed'"
                            [innerHtml]="item.media.embedCode | noSanitize">
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
    <div class="listicle numbered" *ngIf="elementData.listicleBulletType==='number'">
        <ul>
            <li *ngFor="let item of elementData.listicleArray;let i = index">
                <h2><span>{{i+1}}</span></h2>
                <h4>{{item.key}}</h4>
                <p>{{item.value}}</p>
                <div class="listImage">
                    <img *ngIf="item.mediaType === 'image'" src="{{item.media.image.images.original}}">
                    <div class="respVideo" *ngIf="item.mediaType === 'video'"
                        [innerHtml]="item.media.video.body | noSanitize">
                    </div>
                    <div #embedEl >
                        <div class="respVideo" *ngIf="item.mediaType === 'embed'"
                            [innerHtml]="item.media.embedCode | noSanitize">
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
    <div class="listicle doted" *ngIf="elementData.listicleBulletType==='bullet'">
        <ul>
            <li *ngFor="let item of elementData.listicleArray;let i = index">
                <h2><span>{{i+1}}</span></h2>
                <h4>{{item.key}}</h4>
                <p>{{item.value}}</p>
                <div class="listImage">
                    <img *ngIf="item.mediaType === 'image'" src="{{item.media.image.images.original}}">
                    <div class="respVideo" *ngIf="item.mediaType === 'video'"
                        [innerHtml]="item.media.video.body | noSanitize">
                    </div>
                    <div #embedEl  >
                        <div class="respVideo" *ngIf="item.mediaType === 'embed'"
                            [innerHtml]="item.media.embedCode | noSanitize">
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</ng-container>

</div>